import { render } from "./PaintSchemeOption.vue?vue&type=template&id=18c0a482&scoped=true"
import script from "./PaintSchemeOption.vue?vue&type=script&lang=js"
export * from "./PaintSchemeOption.vue?vue&type=script&lang=js"

import "./PaintSchemeOption.vue?vue&type=style&index=0&id=18c0a482&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c0a482"]])

export default __exports__